"use strict";

function getParameterByName(name, url) {
    void 0 === url && (url = window.location.href), name = name.replace(/[\[\]]/g, "\\$&");
    var results = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)").exec(url);
    return results ? results[2] ? decodeURIComponent(results[2].replace(/\+/g, " ")) : "" : null;
}

function googleAPIReady() {
    var input = document.querySelector(".js-suburb input"), autocomplete = new google.maps.places.Autocomplete(input, {
        fields: [ "address_components" ],
        location: "-37.81026435967752, 144.96404552182014",
        radius: 31e4
    });
    autocomplete.addListener("place_changed", (function() {
        for (var details = autocomplete.getPlace(), value = "", i = 0; i < details.address_components.length; i++) {
            for (var detail = details.address_components[i], x = 0; x < detail.types.length; x++) if ("locality" === detail.types[x]) {
                value = detail.long_name;
                break;
            }
            if ("" !== value) break;
        }
        input.value = value;
    }));
}

!function($, window, document) {
    var $isotope, root = document.documentElement, $win = $(window), $doc = $(document), $body = $("body"), $header = $(".header"), $footer = $(".js-footer-height"), $subnav = $(".subnav"), headerHeight = $header.outerHeight(), footerHeight = $footer.outerHeight(), subnavHeight = $subnav.outerHeight(), isMobileView = $win.width() < 767, scrollTop = $win.scrollTop(), $stickyHolder = $(".sticky-holder"), stickyHeight = $stickyHolder.find(".sticky__inner").outerHeight(), transitioning = ($(".js-append-articles"), 
    $(".js-append-article"), $(".js-map-filters"), $(".section-gmap"), !1);
    let maps = [], mapCenters = [];
    $win.width();
    function resizeHero() {
        $(".section--overlay").each((function() {
            var $next = $(this).next();
            if ($next.is(".section--text")) {
                var height = "calc(100vh - " + $next.outerHeight() + "px)";
                $(this).find(".hero__content").css("max-height", height);
            }
        }));
    }
    function mobileSliders() {
        $(".js-slider-mobile .slider__slides").each((function() {
            var $slider = $(this);
            isMobileView ? (!function destroyIsotope() {
                var $projects = $(".section--projects");
                $projects.length > 0 && $projects.each((function() {
                    if ($(this).find(".projects__items").hasClass("js-slider-mobile")) {
                        var $projectsWrapper = $(this).find(".projects__projects");
                        $projectsWrapper.data("isotope") && $projectsWrapper.isotope("destroy");
                    }
                }));
            }(), $slider.hasClass("slick-initialized") || $slider.slick({
                mobileFirst: !0,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: !0,
                adaptiveHeight: !0
            })) : $slider.hasClass("slick-initialized") && $slider.slick("unslick");
        }));
    }
    function setPaggingToSlider(slick, activeSlide) {
        var $slickPaging = slick.$list.parent().siblings(".slider__paging"), slidesCount = slick.slideCount, htmlSliderCurrent = $slickPaging.find("span").eq(0), htmlSliderCount = $slickPaging.find("span").eq(1);
        htmlSliderCurrent.html(activeSlide + 1), htmlSliderCount.html(slidesCount);
    }
    function getInnerColForGrid() {
        $(".js-grid-borders").each((function(index, element) {
            var $colParent = $(element), colParentOffsetLeft = $colParent.offset().left;
            $colParent.children(".grid__col").each((function(inx, col) {
                var $col = $(col), colOffsetLeft = $col.offset().left, isInnerColumn = colParentOffsetLeft + 2 < colOffsetLeft;
                $col.toggleClass("has-border", isInnerColumn);
            }));
        }));
    }
    $(document).click((function(event) {
        0 === $(event.target).closest(".header").length && $("body").removeClass("is-nav-open");
    })), $(window).resize((function() {
        resizeHero();
    })), resizeHero(), function initIsotope() {
        var $projects = $(".section--projects");
        $projects.length > 0 && $projects.each((function() {
            var $projectsWrapper = $(this).find(".projects__projects");
            if (!isMobileView) {
                var activeFilter = $(".js-projects-filters .active").data("filter"), filter = getParameterByName("filter");
                $isotope = $projectsWrapper.isotope({
                    itemSelector: ".projects__project",
                    layoutMode: "masonry",
                    resize: !0,
                    filter: activeFilter
                }), null !== filter && ($isotope.isotope({
                    filter: ".state-" + filter
                }), $(".filter-state-" + filter).closest(".js-projects-filters").find("a").removeClass("active"), 
                $(".filter-state-" + filter).addClass("active"));
            }
            $(".js-projects-filters a").click((function(event) {
                event.preventDefault();
                var filter = $(this).data("filter");
                $(this).closest(".js-projects-filters").find("a").removeClass("active"), $(this).addClass("active"), 
                isMobileView ? "*" === filter ? $projectsWrapper.slick("slickUnfilter") : ($projectsWrapper.slick("slickUnfilter"), 
                $projectsWrapper.slick("slickFilter", filter)) : $isotope.isotope({
                    filter: filter
                });
            }));
        }));
    }(), $(document).ready((function() {
        var $listMap = $(".js-list-map");
        if ($listMap.length > 0) {
            var $listMapMapEl = $listMap.find(".list-map__map"), $listMapLinks = $listMap.find(".js-list-map-links a"), mapData = loadAjax($listMapMapEl.data("mapdata")), listMapLocations = window.listMapLocations, listMapMap = new google.maps.Map($listMapMapEl.get(0), {
                styles: mapData.styles,
                maxZoom: 16
            }), listMapMarkers = [], listMapBounds = new google.maps.LatLngBounds, iconBase = {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 7,
                fillColor: "#ccc",
                fillOpacity: 1,
                strokeWeight: 0
            };
            $.each(listMapLocations, (function(index, location) {
                var position = {
                    lat: location.lat,
                    lng: location.lng
                }, marker = new google.maps.Marker({
                    position: position,
                    map: listMapMap,
                    icon: iconBase,
                    data: location
                });
                google.maps.event.addListener(marker, "mouseover", (function() {
                    $listMapLinks.removeClass("active"), $('.js-list-map-links a[data-id="' + marker.data.id + '"]').addClass("active");
                    var icon = JSON.parse(JSON.stringify(iconBase));
                    icon.fillColor = "#000", marker.setIcon(icon), marker.setZIndex(10);
                })), google.maps.event.addListener(marker, "mouseout", (function() {
                    $('.js-list-map-links a[data-id="' + marker.data.id + '"]').removeClass("active"), 
                    marker.setIcon(iconBase), marker.setZIndex(1);
                })), listMapBounds.extend(position), listMapMarkers.push(marker);
            })), listMapMap.fitBounds(listMapBounds), $listMapLinks.hover((function(event) {
                $listMapLinks.removeClass("active"), $(this).addClass("active"), event.preventDefault();
                var id = $(this).data("id");
                $.each(listMapMarkers, (function(index, marker) {
                    if (marker.data.id == id) {
                        var icon = JSON.parse(JSON.stringify(iconBase));
                        icon.fillColor = "#000", marker.setIcon(icon), marker.setZIndex(10);
                    } else marker.setIcon(iconBase), marker.setZIndex(1);
                }));
            }));
        }
    }));
    function loadAjax(filePath) {
        return $.ajax({
            async: !1,
            global: !1,
            url: filePath
        }).responseJSON;
    }
    $(".js-nav-trigger").on("click", (function(e) {
        e.preventDefault(), $body.toggleClass("is-nav-open");
    })), $(".subnav .subnav__head").on("click", (function(e) {
        e.preventDefault(), $(".subnav").toggleClass("is-expanded"), $(".subnav .subnav__body").slideToggle();
    })), $(".js-scroll-arrow").on("click", (function(e) {
        $("html, body").animate({
            scrollTop: $(".js-nav-scrollspy").offset().top
        }, 1250);
    })), $(".js-tabs a").on("click", (function(e) {
        var $tabLink = $(this), $targetTab = $($tabLink.attr("href"));
        $tabLink.parent().add($targetTab).addClass("is-active").siblings().removeClass("is-active"), 
        e.preventDefault();
    })), function initScrollspy() {
        var $srollSpyNav = arguments.length <= 0 || void 0 === arguments[0] ? $(".js-nav-scrollspy") : arguments[0], $scrollSpySection = arguments.length <= 1 || void 0 === arguments[1] ? $(".js-scrollspy-section") : arguments[1], $srollSpyNavLinkHolder = $srollSpyNav.find("li"), $srollSpyNavLink = $srollSpyNav.find("a");
        $srollSpyNavLink.on("click", (function() {
            var target = $(this).attr("href");
            $("html, body").animate({
                scrollTop: $(target).offset().top - stickyHeight - headerHeight
            }, 1e3);
        })), $win.on("load scroll", (function() {
            !function setScrollspyActiveStates() {
                $scrollSpySection.each((function() {
                    var $this = $(this);
                    if ($this.offset().top <= scrollTop + headerHeight + stickyHeight + 2) {
                        var id = $this.attr("id");
                        $srollSpyNavLinkHolder.removeClass("is-active"), $srollSpyNav.find('a[href="#' + id + '"]').closest("li").addClass("is-active");
                    }
                }));
            }();
        }));
    }(), function chartPie() {
        if ($(".js-chart-pie").length) {
            for (var $chart = $(".js-chart-pie"), chartData = $chart.data("piece"), $chartText = $chart.find(".chart__data li"), rotateAlready = 0, $chartBg = $chart.find(".chart__bg").find("li"), i = 0; i < chartData.length; i++) {
                var rotate = 360 * chartData[i] / 100, rotateText = rotateAlready + rotate / 2;
                $chartText.eq(i).css("transform", "translate(-50%, 0) rotate(" + rotateText + "deg)").find("span").eq(0).css("transform", "rotate(" + -rotateText + "deg)"), 
                $chartText.eq(i).find("span").eq(1).css("transform", "rotate(" + rotateText + "deg)"), 
                rotateAlready += rotate;
            }
            var rotateFirst = 360 * chartData[0] / 100;
            if (rotateFirst < 180) $chartBg.eq(1).find("span").css("transform", "rotate(" + rotateFirst + "deg)"); else {
                var rotateLast = rotateFirst - 180;
                $chartBg.eq(1).find("span").css("transform", "rotate(180deg)"), $chartBg.eq(0).find("span").css("transform", "rotate(" + rotateLast + "deg)");
            }
        }
    }(), function lineChart() {
        $(".js-line-chart").each((function(index, element) {
            var $this = $(element), status = $this.data("line-chart-status");
            $this.css("background-position", "100" - status + "%");
        }));
    }(), $win.on("load", (function() {
        !function intPopups() {
            $(".modules").magnificPopup({
                delegate: ".js-popup-image",
                type: "image",
                closeOnContentClick: !0,
                fixedContentPos: !0,
                tLoading: "Loading image #%curr%...",
                mainClass: "mfp-img-mobile",
                gallery: {
                    enabled: !0,
                    navigateByImgClick: !0,
                    preload: [ 0, 1 ]
                },
                image: {
                    verticalFit: !0,
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                    titleSrc: function titleSrc(item) {
                        return item.el.attr("title");
                    }
                }
            });
        }(), function intSlider() {
            $(".js-slider-hero .slider__slides:not(.slick-initialized)").on("init", (function(slick, currentSlide) {
                var $video = $(currentSlide.$slides).eq(0).find("video");
                $video.length && $video[0].play();
            })).slick({
                infinite: !0,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: !0,
                autoplaySpeed: 3500
            }).on("beforeChange", (function(event, slick, currentSlide, nextSlide) {
                var $slides = slick.$slides, $videos = $slides.find("video"), $nextSlideVideo = $($slides[nextSlide]).eq(0).find("video");
                $videos.each((function(index, video) {
                    video.pause();
                })), $nextSlideVideo.length && $nextSlideVideo[0].play();
            })), $(".js-slider-gallery:not(.slick-initialized)").each((function(index, slider) {
                var $slider = $(slider), $sliderMedia = $slider.find(".slider__media"), $sliderContent = $slider.find(".slider__content");
                $sliderMedia.on("init", (function(event, slick, currentSlide, nextSlide) {
                    setPaggingToSlider(slick, 0);
                })).slick({
                    slidesToShow: 1,
                    infinite: !1,
                    slidesToScroll: 1,
                    arrows: !0,
                    asNavFor: $sliderContent,
                    adaptiveHeight: !0
                }).on("beforeChange", (function(event, slick, currentSlide, nextSlide) {
                    setPaggingToSlider(slick, nextSlide);
                })), $sliderContent.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: !1,
                    fade: !0,
                    asNavFor: $sliderMedia
                });
            })), $(".js-slider-gallery-base .slider__media").on("init", (function(event, slick, currentSlide, nextSlide) {
                setPaggingToSlider(slick, 0);
            })).slick({
                slidesToShow: 1,
                infinite: !1,
                slidesToScroll: 1,
                arrows: !0,
                adaptiveHeight: !0
            }).on("beforeChange", (function(event, slick, currentSlide, nextSlide) {
                setPaggingToSlider(slick, nextSlide);
            }));
            var $sliderSlickMain = $(".js-slider-line .slider__slides--main"), $sliderSlickThumbs = $(".js-slider-line .slider__slides--thumbs");
            $sliderSlickMain.length && $sliderSlickMain.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !1,
                fade: !0,
                asNavFor: $sliderSlickThumbs,
                autoplay: !0,
                autoplaySpeed: 3e3
            }), $sliderSlickThumbs.length && $sliderSlickThumbs.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: $sliderSlickMain,
                arrows: !1,
                focusOnSelect: !0
            }), $(".js-slider-team .slider__slides:not(.slick-initialized)").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: !1,
                mobileFirst: !0,
                responsive: [ {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2.5
                    }
                } ]
            }), $(".js-slider-team--alt .slider__slides:not(.slick-initialized)").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !1,
                arrows: !0,
                mobileFirst: !0,
                responsive: [ {
                    breakpoint: 767,
                    settings: {
                        arrows: !0,
                        slidesToShow: 3.21,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 1024,
                    settings: {
                        arrows: !1,
                        slidesToShow: 5,
                        slidesToScroll: 1
                    }
                } ]
            }), $(".slider.slider--alt:not(.slick-initialized)").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !0,
                dots: !0
            }), $(".js-slider-vision .slider__slides:not(.slick-initialized)").on("init", (function(event, slick, currentSlide, nextSlide) {
                setPaggingToSlider(slick, 0);
            })).slick({
                slidesToShow: 1,
                arrows: !1,
                adaptiveHeight: !0
            }).on("beforeChange", (function(event, slick, currentSlide, nextSlide) {
                setPaggingToSlider(slick, nextSlide);
            })), $(".js-slider-selings .slider__slides:not(.slick-initialized)").slick({
                slidesToShow: 4,
                responsive: [ {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2.5
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        centerMode: !0,
                        centerPadding: "9.3rem 0 0"
                    }
                } ]
            }), $(".js-slider-residences .slider__slides:not(.slick-initialized)").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: !0,
                infinite: !1,
                dots: !1,
                responsive: [ {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                } ]
            });
        }(), function initPlyrVideos() {
            $(".video").each((function() {
                const video_id = $(this).attr("id");
                new Plyr("#" + video_id);
            }));
        }(), getInnerColForGrid(), function initMenuButton() {
            $(".js-menu-button").on("click", (function() {
                $(this).toggleClass("active"), $(".header__menu-items-mobile").hasClass("visible") ? ($(".header__menu-items-mobile").toggleClass("visible"), 
                setTimeout((function() {
                    $(".header__menu-items-mobile").toggleClass("active");
                }), 400)) : ($(".header__menu-items-mobile").toggleClass("active"), document.body.offsetHeight, 
                $(".header__menu-items-mobile").toggleClass("visible"));
            }));
        }(), function initMenuLinks() {
            $(".header__menu-items li a").on("click", (function(e) {
                e.preventDefault();
                let $this = $(this), $parent = $this.parent();
                const id = $this.attr("href");
                $(".header__menu-items li").removeClass("active"), $parent.addClass("active"), id && (transitioning = !0, 
                $("html, body").animate({
                    scrollTop: $(id).offset().top - 25
                }, 1e3, "swing", (function() {
                    setTimeout((function() {
                        transitioning = !1;
                    }), 250);
                }))), $(".header__menu-items-mobile").hasClass("active") && $(".js-menu-button").trigger("click");
            })), $("#js-scroll-hero").on("click", (function(e) {
                e.preventDefault(), $("html, body").animate({
                    scrollTop: $win.outerHeight() - 25
                }, 1e3);
            })), $('a[href="#popup-enquire"]').on("click", (function(e) {
                e.preventDefault(), $("#popup-enquire").toggleClass("active"), $(".header").toggleClass("popup-active");
            }));
        }(), function initFormLabels() {
            $doc.on("gform_post_render", (function(event, form_id, current_page) {
                $doc.find("#gform_wrapper_" + form_id).find("input").each((function() {
                    let $parent, $label, $this = $(this);
                    $this.parent().hasClass("ginput_container") ? ($parent = $this.parents(".gfield").eq(0), 
                    $label = $parent.find("label")) : ($parent = $this.parent(), $label = $parent.find("label")), 
                    $this.val().length > 0 && $label.addClass("active");
                })), googleAPIReady();
            })), $doc.on("focus", "#popup-enquire input", (function(e) {
                let $parent, $label, $this = $(this);
                $this.parent().hasClass("ginput_container") ? ($parent = $this.parents(".gfield").eq(0), 
                $label = $parent.find("label")) : ($parent = $this.parent(), $label = $parent.find("label")), 
                $label.addClass("active");
            })), $doc.on("blur", "#popup-enquire input", (function(e) {
                let $parent, $label, $this = $(this);
                $this.parent().hasClass("ginput_container") ? ($parent = $this.parents(".gfield").eq(0), 
                $label = $parent.find("label")) : ($parent = $this.parent(), $label = $parent.find("label")), 
                0 == $this.val().length && $label.removeClass("active");
            }));
        }(), function initPopupGallery() {
            $(".js-popup-gallery-container").each((function() {
                $(this).magnificPopup({
                    delegate: ".js-gallery-item",
                    type: "image",
                    tLoading: "Loading image #%curr%...",
                    mainClass: "mfp-img-mobile",
                    fixedContentPos: !0,
                    gallery: {
                        enabled: !0,
                        navigateByImgClick: !0,
                        preload: [ 0, 1 ]
                    },
                    image: {
                        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                        titleSrc: function titleSrc(item) {
                            return item.el.attr("title");
                        }
                    }
                });
            }));
        }(), function initMapNew() {
            $doc.find(".map").each((function() {
                let $this = $(this);
                const lat = $this.data("lat"), lng = $this.data("lng"), mapData = loadAjax($this.data("mapdata")), zoom = $this.data("zoom"), markerData = $this.data("pins"), center = {
                    lat: lat,
                    lng: lng
                }, map = new google.maps.Map(document.getElementById($this.attr("id")), {
                    center: center,
                    zoom: zoom,
                    styles: mapData.styles,
                    gestureHandling: "greedy"
                });
                maps.push(map), mapCenters.push(center);
                for (var i = 0; i < markerData.length; i++) {
                    const _marker = markerData[i], markerSettings = {
                        position: {
                            lat: parseFloat(_marker.map_pin.lat),
                            lng: parseFloat(_marker.map_pin.lng)
                        },
                        map: map
                    };
                    if (void 0 !== _marker.custom_pin && !1 !== _marker.custom_pin && _marker.custom_pin.length > 0) markerSettings.icon = _marker.custom_pin; else {
                        const icon = {
                            path: google.maps.SymbolPath.CIRCLE,
                            scale: 7,
                            fillOpacity: 1,
                            strokeWeight: 0
                        };
                        void 0 !== _marker.pin_colour && !1 !== _marker.pin_colour && _marker.pin_colour.length > 0 ? icon.fillColor = _marker.pin_colour : icon.fillColor = "#000", 
                        markerSettings.icon = icon;
                    }
                    new google.maps.Marker(markerSettings);
                }
            }));
        }();
    })).on("load resize", (function() {
        !function getSizes() {
            headerHeight = $header.outerHeight(), footerHeight = $footer.outerHeight(), subnavHeight = $subnav.outerHeight(), 
            isMobileView = $win.width() < 767;
        }(), function updateVariables() {
            root.style.setProperty("--header-height", headerHeight + "px"), root.style.setProperty("--footer-height", footerHeight + "px"), 
            root.style.setProperty("--subnav-height", subnavHeight + "px");
        }(), function stickySize() {
            $stickyHolder.css("min-height", headerHeight + "px");
        }(), getInnerColForGrid(), $win.width() > 1198 && ($(".header__menu-items-mobile").removeClass("active visible"), 
        $(".header__menu-btn").removeClass("active")), $win.width() < 767 ? maps.forEach(((_map, _index) => {
            _map.setZoom(14);
            const lat = parseFloat(mapCenters[_index].lat), lng = parseFloat(mapCenters[_index].lng);
            _map.setCenter(new google.maps.LatLng(lat, lng));
        })) : maps.forEach(((_map, _index) => {
            _map.setZoom(16);
            const lat = parseFloat(mapCenters[_index].lat), lng = parseFloat(mapCenters[_index].lng);
            _map.setCenter(new google.maps.LatLng(lat, lng));
        })), $win.width();
    })).on("load scroll", (function() {
        !function animateOnScroll() {
            $(".js-animate").each((function(index, element) {
                var $this = $(element), animateStart = $this.attr("data-start");
                $this.offset().top + $this.outerHeight() * animateStart < scrollTop + $win.outerHeight() && $this.addClass("is-animated");
            }));
        }(), function stickyDetect() {
            if ($(".sticky-holder").length) {
                var stickyOffset = $stickyHolder.offset().top, becomeSticky = scrollTop > stickyOffset - headerHeight;
                $stickyHolder.toggleClass("is-sticky", becomeSticky);
            }
        }(), scrollTop = $win.scrollTop(), function updateMenuItemActiveState() {
            if (!transitioning) {
                const ids = [], positions = [];
                $("section").each((function() {
                    let $this = $(this);
                    void 0 !== $this.attr("id") && $this.attr("id").length && (ids.push("#" + $this.attr("id")), 
                    positions.push($this.offset().top));
                }));
                for (var i = 0; i < ids.length; i++) $win.scrollTop() >= positions[i] - 50 && ($(".header__menu-items li").removeClass("active"), 
                $('.header__menu-items li a[href="' + ids[i] + '"]').parent().addClass("active"));
                $win.scrollTop() < positions[0] - 50 && $(".header__menu-items li").removeClass("active");
            }
        }(), function stuckElement(winST) {
            $(".js-stuck").length && $(".js-section").each((function() {
                var $this = $(this), $holder = $this.find(".js-stuck"), stickCondition = winST + headerHeight >= $this.offset().top && winST < $this.offset().top + $this.outerHeight() - $holder.outerHeight(), bottomCondition = winST >= $this.offset().top + $this.outerHeight() - $holder.outerHeight() - headerHeight;
                stickCondition ? $this.addClass("stuck") : $this.removeClass("stuck"), bottomCondition ? $this.addClass("bottom") : $this.removeClass("bottom");
            }));
        }(scrollTop), function animate(winST) {
            $(".animate").each((function() {
                var $this = $(this);
                winST + $win.outerHeight() / 1.05 > $this.offset().top ? ($this.addClass("animated"), 
                !$this.hasClass("layedout") && $this.hasClass("projects__items") && ($this.addClass("layedout"), 
                void 0 !== $isotope && $isotope.isotope("layout"))) : winST + $win.outerHeight() / 2 < $this.offset().top && $this.removeClass("animated");
            }));
        }(scrollTop);
    })).on("load resize orientationchange", (function() {
        mobileSliders();
    }));
    "objectFit" in document.documentElement.style != !0 && $(".img-fit").each((function() {
        var src = $("img", $(this)).attr("src");
        src && ($(this).css("background-image", "url(" + src + ")"), $(this).addClass("img-fit--fallback"));
    }));
}(jQuery, window, document);